import { useState } from "react";
import {
  Box,
  Button,
  Typography,
  TextField,
  Grid,
  RadioGroup,
  FormControlLabel,
  Radio,
  Chip,
} from "@mui/material";
import CommonAccordion from "../../custom-components/CommonAccordion";
import { ReactComponent as LoadIcon } from "../../../images/loadExampleButton.svg";
import SendIcon from "@mui/icons-material/Send";
import { useLocation, useNavigate } from "react-router-dom";

const SprintDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [accordionStates, setAccordionStates] = useState({
    sprintDetails: true,
  });
  const [resources, setResources] = useState(["Varun Roy", "Aisha Patel"]);
  const [resourceInput, setResourceInput] = useState("");
  const [applicationName, setApplicationName] = useState("");
  const [buildVersion, setBuildVersion] = useState("");
  const [testingType, setTestingType] = useState("");
  const [tool, setTool] = useState("");
  const [environment, setEnvironment] = useState("");

  const handleAddResource = (event) => {
    if (event.key === "Enter" && resourceInput.trim() !== "") {
      const newResource = resourceInput.trim();
      if (
        !resources.some(
          (resource) => resource.toLowerCase() === newResource.toLowerCase()
        )
      ) {
        setResources([...resources, newResource]);
      }
      setResourceInput("");
    }
  };

  const handleDeleteResource = (resourceToDelete) => {
    setResources(resources.filter((resource) => resource !== resourceToDelete));
  };

  const handleFormLoadDemoExample = (e) => {
    e.stopPropagation();
    setApplicationName("Qmentis");
    setBuildVersion("1.0");
    setTestingType("functional");
    setTool("jira");
    setEnvironment("dev");
    setResources(["Varun Roy", "Aisha Patel"]);
  };

  const isNextEnabled = () => {
    return (
      applicationName.trim() !== "" &&
      buildVersion.trim() !== "" &&
      testingType !== "" &&
      tool !== "" &&
      environment !== "" &&
      resources.length > 0
    );
  };

  const handleSprintDetailsNext = () => {
    try {
      let sprintDetailsData = {
        applicationName: applicationName,
        buildVersion: buildVersion,
        testingType: testingType,
        tool: tool,
        environment: environment,
        resources: resources,
      };
      navigate("/dashboard/sprint-summary-report/output", {
        state: { ...location.state, sprintDetailsData: sprintDetailsData },
      });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <CommonAccordion
      summary={
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          width="100%"
        >
          <Typography variant="subtitle1" sx={{ fontSize: "16px" }}>
            Sprint Details
          </Typography>
          {accordionStates.sprintDetails && (
            <Button
              variant="text"
              startIcon={<LoadIcon />}
              sx={{
                ml: 2,
                textTransform: "none",
                position: "relative",
                top: "0px",
              }}
              onClick={handleFormLoadDemoExample}
            >
              Load Demo Example
            </Button>
          )}
        </Box>
      }
      details={
        <Box mb={2}>
          <TextField
            fullWidth
            label="Application Name(s)"
            placeholder="Enter Application Name"
            variant="outlined"
            margin="normal"
            sx={{ width: "90%" }}
            value={applicationName}
            onChange={(e) => setApplicationName(e.target.value)}
          />
          <Typography variant="subtitle2" sx={{ mt: 2, mb: 1 }}>
            Type of Testing
          </Typography>
          <RadioGroup
            value={testingType} // Bind the RadioGroup's value to the state
            onChange={(e) => setTestingType(e.target.value)}
          >
            <Grid container spacing={1}>
              <Grid item xs={6} sx={{ mb: 0 }}>
                <FormControlLabel
                  value="functional"
                  control={<Radio />}
                  label="Functional"
                />
              </Grid>
              <Grid item xs={6} sx={{ mb: 0 }}>
                <FormControlLabel
                  value="integration"
                  control={<Radio />}
                  label="Integration"
                />
              </Grid>
              <Grid item xs={6}>
                <FormControlLabel
                  value="automation"
                  control={<Radio />}
                  label="Automation"
                />
              </Grid>
              <Grid item xs={6}>
                <FormControlLabel
                  value="non-functional"
                  control={<Radio />}
                  label="Non-functional"
                />
              </Grid>
            </Grid>
          </RadioGroup>
          <TextField
            fullWidth
            label="Build(s)/Version(s) Tested"
            placeholder="Enter Build/Version Tested"
            variant="outlined"
            margin="normal"
            sx={{ width: "90%" }}
            value={buildVersion}
            onChange={(e) => setBuildVersion(e.target.value)}
          />
          <Typography variant="subtitle2" sx={{ mt: 2 }}>
            Tool
          </Typography>
          <RadioGroup
            value={tool}
            row
            onChange={(e) => setTool(e.target.value)}
          >
            <FormControlLabel
              value="jira"
              control={<Radio />}
              label="JIRA"
              sx={{ mr: 14 }}
            />
            <FormControlLabel
              value="xray"
              control={<Radio />}
              label="Xray"
              sx={{ mr: 14 }}
            />
            <FormControlLabel
              value="automation-tool"
              control={<Radio />}
              label="Automation Tool"
            />
          </RadioGroup>
          <Typography variant="subtitle2" sx={{ mt: 2 }}>
            Testing Environment(s)
          </Typography>
          <RadioGroup
            value={environment}
            row
            onChange={(e) => setEnvironment(e.target.value)}
          >
            <FormControlLabel
              value="dev"
              control={<Radio />}
              label="Dev Environment"
              sx={{ mr: 3 }}
            />
            <FormControlLabel
              value="test"
              control={<Radio />}
              label="Test Environment"
              sx={{ mr: 3 }}
            />
            <FormControlLabel
              value="sit"
              control={<Radio />}
              label="SIT Environment"
            />
          </RadioGroup>
          <TextField
            fullWidth
            label="Add Resources"
            placeholder="Enter Resource Name and Press Enter"
            variant="outlined"
            margin="normal"
            sx={{ width: "90%" }}
            value={resourceInput}
            onChange={(e) => setResourceInput(e.target.value)}
            onKeyDown={handleAddResource}
          />
          <Box mt={1} display="flex" flexWrap="wrap" gap={1}>
            {resources.map((resource, index) => (
              <Chip
                key={index}
                label={resource}
                onDelete={() => handleDeleteResource(resource)}
              />
            ))}
          </Box>
        </Box>
      }
      buttons={[
        {
          label: "Next",
          variant: "contained",
          startIcon: <SendIcon />,
          onClick: handleSprintDetailsNext,

          sx: {
            float: "right",
            textTransform: "none",
            backgroundColor: isNextEnabled() ? "#49A3FF" : "grey",
            color: isNextEnabled() ? "white" : "black",
            "&:hover": {
              backgroundColor: isNextEnabled() ? "#49A3FF" : "darkgrey",
            },
          },
          disabled: !isNextEnabled(),
        },
      ]}
    />
  );
};

export default SprintDetails;
